import { restApiRP } from "@plannel/services/utils/rest-api";

const getAll = params => {
    return restApiRP.get("/api/rp/procurement-status", { params });
}

const getAllForCSV = params => {
    return restApiRP.get("/api/rp/procurement-status/csv", { params });
}

const rpProcurmentStatusService = {
    getAll,
    getAllForCSV
};

export default rpProcurmentStatusService;